import * as React from "react"

const SvgRoute = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M19 21.286q-.975 0-1.75-.563a2.9 2.9 0 0 1-1.075-1.437H11q-1.65 0-2.825-1.175T7 15.286c0-1.65.392-2.042 1.175-2.825Q9.35 11.285 11 11.286h2q.825 0 1.412-.588Q15 10.11 15 9.286q0-.825-.588-1.413A1.93 1.93 0 0 0 13 7.286H7.825a3.1 3.1 0 0 1-1.088 1.437A2.85 2.85 0 0 1 5 9.286a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 2 6.286q0-1.25.875-2.125A2.9 2.9 0 0 1 5 3.286q.976 0 1.737.562.763.562 1.088 1.438H13q1.65 0 2.825 1.175T17 9.286c0 1.65-.392 2.041-1.175 2.825Q14.65 13.286 13 13.286h-2q-.825 0-1.412.587A1.93 1.93 0 0 0 9 15.286q0 .825.588 1.412.587.588 1.412.588h5.175a3.1 3.1 0 0 1 1.087-1.438A2.85 2.85 0 0 1 19 15.286a2.9 2.9 0 0 1 2.125.875q.875.874.875 2.125t-.875 2.125a2.9 2.9 0 0 1-2.125.875m-14-14a.97.97 0 0 0 .713-.288A.97.97 0 0 0 6 6.286a.97.97 0 0 0-.287-.713A.97.97 0 0 0 5 5.286a.97.97 0 0 0-.713.287.97.97 0 0 0-.287.713q0 .424.287.712.288.288.713.288" />
  </svg>
)
export default SvgRoute
